import React from 'react'

import { Field } from 'formik'

import { A, Button, InlineWarning } from '@driftt/tide-core'

import C from '../constants'

import styles from '../styles.module.css'

const TopSection: React.FC<{ formikValues: Record<string, any> }> = ({ formikValues }) => (
  <section>
    <div className={styles.subtextAndSnoozeContainer}>
      <div className={styles.notificationContentSubtext}>
        Get notified about conversations and account activity on your site.
        <div>
          <A target="external" href={C.NOTIFICATIONS_HELP_LINK}>
            Learn more
          </A>
        </div>
      </div>
      <Field name="properties.notifications-snoozed">
        {({ form, field }: any) => (
          <>
            <Button
              type={field.value === true ? 'secondary' : 'tertiary'}
              size="medium"
              className={styles.button}
              onClick={() => form.setFieldValue(field.name, !field.value)}>
              {field.value === true ? 'Turn on notifications' : 'Snooze notifications'}
            </Button>
          </>
        )}
      </Field>
    </div>
    {formikValues?.properties['notifications-snoozed'] === true && (
      <div>
        <InlineWarning title="Notifications snoozed" type="warning" className={styles.warning}>
          Drift won’t send you notifications on desktop, email, and mobile. Turn on notifications to
          get alerted about important activity like new conversations or target accounts on your
          site.
        </InlineWarning>
      </div>
    )}
  </section>
)

export default TopSection
